// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//
import { sync } from 'vuex-router-sync'
import Vue from 'vue'
import Vuex from 'vuex'

import App from './App'
import store from './vuex/store'
import router from './router'
import plugins from './plugins'
import components from './components'

/**
 * Routes
 */
Vue.router = router
Vue.use(Vuex)
sync(store, router)

/**
 * Plugins and components
 */
Vue.use(plugins)
Vue.use(components)

Vue.use(require('@websanova/vue-auth'), {
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),

  auth: {
    request (req, token) {
      token = JSON.parse(token) || {}

      const accessToken = token.access_token

      if (accessToken) {
        this.options.http._setHeaders.call(this, req, { Authorization: `Bearer ${accessToken}` })
      }

      return null
    },

    response (res) {
      const headers = this.options.http._getHeaders.call(this, res)
      let token = headers.Authorization || headers.authorization

      if (token) {
        token = token.split(/Bearer:?\s?/i)
        return token[token.length > 1 ? 1 : 0].trim()
      }

      return (res.data || {}).access_token ? JSON.stringify(res.data) : null
    }
  },

  // Auth routes
  authRedirect: { name: 'auth.login' },

  loginData: { url: 'login', method: 'POST', redirect: { name: 'index' }, fetchUser: false },
  refreshData: {
    url: 'refresh',
    method: 'POST',
    fetchUser: false,
    interval: 10080,
    error () {
      store.dispatch('errors/pushGlobalError', [{
        message: 'Ocorreu um problema. Por favor faça o login.'
      }])
      store.dispatch('auth/revokeToken')
      router.push({ name: 'auth.login' })
    }
  },
  fetchData: { url: 'whoami', method: 'GET', enabled: true }
})

Vue.config.productionTip = true

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js